!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e(require("react")) : "function" == typeof define && define.amd ? define(["react"], e) : "object" == typeof exports ? exports.ReactMCarousel = e(require("react")) : t.ReactMCarousel = e(t.react);
}(window, function (t) {
  return function (t) {
    var e = {};

    function n(o) {
      if (e[o]) return e[o].exports;
      var r = e[o] = {
        i: o,
        l: !1,
        exports: {}
      };
      return t[o].call(r.exports, r, r.exports, n), r.l = !0, r.exports;
    }

    return n.m = t, n.c = e, n.d = function (t, e, o) {
      n.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: o
      });
    }, n.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, n.t = function (t, e) {
      if (1 & e && (t = n(t)), 8 & e) return t;
      if (4 & e && "object" == typeof t && t && t.__esModule) return t;
      var o = Object.create(null);
      if (n.r(o), Object.defineProperty(o, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var r in t) {
        n.d(o, r, function (e) {
          return t[e];
        }.bind(null, r));
      }
      return o;
    }, n.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return n.d(e, "a", e), e;
    }, n.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, n.p = "", n(n.s = 1);
  }([function (e, n) {
    e.exports = t;
  }, function (t, e, n) {
    "use strict";

    n.r(e);

    var o = n(0),
        r = n.n(o),
        i = Object.assign || function (t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = arguments[e];

        for (var o in n) {
          Object.prototype.hasOwnProperty.call(n, o) && (t[o] = n[o]);
        }
      }

      return t;
    },
        a = function () {
      function t(t, e) {
        for (var n = 0; n < e.length; n++) {
          var o = e[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(t, o.key, o);
        }
      }

      return function (e, n, o) {
        return n && t(e.prototype, n), o && t(e, o), e;
      };
    }();

    var c = {
      position: "relative",
      width: "100%",
      overflow: "hidden"
    };

    function u(t) {
      return function (e) {
        return r.a.createElement("div", {
          className: "m-carousel-item",
          style: t
        }, e);
      };
    }

    var s = function (t) {
      function e(t) {
        !function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, e);

        var n = function (t, e) {
          if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !e || "object" != typeof e && "function" != typeof e ? t : e;
        }(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t));

        return n.animate = function (t) {
          var e = n.props,
              o = e.children,
              i = e.loop,
              a = e.auto,
              c = e.onAnimationEnd,
              u = n.state,
              s = u.width,
              l = u.active,
              f = u.delta,
              p = r.a.Children.count(o),
              d = p - 1;
          i ? t > d + 1 ? t = d + 1 : t < -1 && (t = -1) : t > d ? t = a ? 0 : d : t < 0 && (t = a ? d : 0);
          var h = {
            active: t,
            delta: 0,
            transitionDuration: Math.abs(s * (l - t) + f) >> 1
          };
          n.setState(h, n.prepareNextAction), "function" == typeof c && c((t + p) % p);
        }, n.prepareNextAction = function (t) {
          var e = n.props,
              o = e.children,
              i = e.auto,
              a = n.state,
              c = a.transitionDuration,
              u = a.active,
              s = r.a.Children.count(o) - 1,
              l = u;
          u > s ? l = 0 : u < 0 && (l = s), l !== u && setTimeout(function () {
            n.setState({
              transitionDuration: 0,
              active: l
            });
          }, c), i && s > 0 && (clearTimeout(n.timer), n.timer = setTimeout(function () {
            n.animate(l + 1);
          }, i));
        }, n.touchStart = function (t) {
          clearTimeout(n.timer), n.direction = void 0, n.setState({
            startX: t.touches[0].clientX,
            startY: t.touches[0].clientY,
            startTime: Date.now(),
            transitionDuration: 0
          });
        }, n.touchMove = function (t) {
          var e = n.props.onSwiping,
              o = n.state,
              r = o.width,
              i = o.startX,
              a = o.startY,
              c = t.changedTouches[0].clientX,
              u = t.changedTouches[0].clientY;
          n.direction || (n.direction = Math.abs(i - c) >= Math.abs(a - u) ? "horizontal" : "vertical"), "horizontal" === n.direction && (n.setState({
            delta: i - c
          }), "function" == typeof e && e((i - c) / r));
        }, n.touchEnd = function (t) {
          var e = n.state,
              o = e.active,
              r = e.delta,
              i = o;
          Math.abs(r) > n.props.delta && (i = o + (r >= 0 ? 1 : -1)), n.animate(i);
        }, n.rootRef = r.a.createRef(), n.state = {
          width: 0,
          active: t.active,
          delta: 0,
          transitionDuration: 0,
          startX: 0,
          startY: 0,
          startTime: Date.now()
        }, n;
      }

      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
      }(e, o["Component"]), a(e, [{
        key: "componentDidMount",
        value: function value() {
          this.setState({
            width: this.rootRef.current.getBoundingClientRect().width
          }, this.prepareNextAction);
        }
      }, {
        key: "render",
        value: function value() {
          var t = this.props,
              e = t.children,
              n = t.responsive,
              o = t.className,
              a = t.style,
              s = t.loop,
              l = t.indicator,
              f = this.state,
              p = f.width,
              d = f.active,
              h = f.delta,
              m = f.transitionDuration,
              v = {
            position: "relative",
            display: "inline-block",
            height: "100%",
            width: p
          },
              b = r.a.Children.count(e),
              y = null,
              w = null,
              x = 0;
          b > 1 && s && (x = 1, y = u(v)(e[b - 1]), w = u(v)(e[0]));
          var g = i({}, c, a);
          0 !== n && (g.height = 0, g.paddingBottom = n + "%");
          var T = {
            position: "absolute",
            height: "100%",
            minWidth: "100%",
            whiteSpace: "nowrap",
            MsTransform: "translate(" + (-p * (d + x) - h) + "px, 0px) translateZ(0px)",
            WebkitTransform: "translate(" + (-p * (d + x) - h) + "px, 0px) translateZ(0px)",
            transform: "translate(" + (-p * (d + x) - h) + "px, 0px) translateZ(0px)",
            MsTransitionDuration: m + "ms",
            WebkitTransitionDuration: m + "ms",
            transitionDuration: m + "ms"
          };
          return r.a.createElement("div", {
            className: "m-carousel " + o,
            onTouchStart: this.touchStart,
            onTouchMove: this.touchMove,
            onTouchEnd: this.touchEnd,
            onTouchCancel: this.touchEnd,
            style: g,
            ref: this.rootRef
          }, r.a.createElement("div", {
            className: "m-carousel-track",
            style: T
          }, y, r.a.Children.map(e, u(v)), w), l(b, d, this.animate));
        }
      }]), e;
    }();

    s.defaultProps = {
      flickThreshold: .6,
      delta: 50,
      className: "",
      responsive: 40,
      active: 0,
      onAnimationEnd: !1,
      onSwiping: !1,
      auto: 0,
      loop: !1,
      indicator: function indicator(t, e, n) {
        return null;
      }
    }, e.default = s;
  }]);
});